import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=0b2040dd&"
import script from "./Items.vue?vue&type=script&lang=js&"
export * from "./Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b2040dd')) {
      api.createRecord('0b2040dd', component.options)
    } else {
      api.reload('0b2040dd', component.options)
    }
    module.hot.accept("./Items.vue?vue&type=template&id=0b2040dd&", function () {
      api.rerender('0b2040dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "backoffice/themes/base/src/views/Items.vue"
export default component.exports